import { h } from 'preact';
import * as BaseComp from 'components/bolt/signUpForm/signUpForm.js';
// import s from 'components/bolt/signUpForm/signUpForm.sss';

export default class SignUpForm extends BaseComp.default {




	componentDidUpdate(prevProps, prevState) {
		if (prevProps.clientData.deviceSize !== this.props.clientData.deviceSize) {
			this.restrictLegalCopyWidth();
		}
		if (
			(prevState.oneTrustAllowed !== this.state.oneTrustAllowed) ||
			(prevProps.cookies !== this.props.cookies) ||
			// (prevProps.externalCookieBanner !== this.props.externalCookieBanner) ||
			(prevProps.activePage !== this.props.activePage)
		) {
			this.checkIfCanShowBanner();
		}
	}
}
